import { FunctionComponent } from 'react'
import Header from '../../components/Header'
import FrameJohnCarter from '../../components/FrameJohnCarter'
import WorldOfCryptic from '../../components/WorldOfCryptic'
import styles from './index.module.scss'

const CLSitedesktopcontact: FunctionComponent = () => {
  return (
    <div className={styles.clSitedesktopcontact}>
      <Header />
      <section className={styles.frameInputForm}>
        <div className={styles.frameGetInTouch}>
          <h1 className={styles.getInTouch}>Get in touch</h1>
        </div>
        <div className={styles.frameNameEmail}>
          <FrameJohnCarter />
        </div>
      </section>
      <WorldOfCryptic />
    </div>
  )
}

export default CLSitedesktopcontact
